import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'directories.filters-v2.main.content.empty.header',
		defaultMessage: "You don't have any filters",
		description:
			'Heading for the empty state (empty screen) which is displayed for users on filters page in case there are no filters user has access to',
	},
	description: {
		id: 'directories.filters-v2.main.content.empty.description',
		defaultMessage:
			'You can create a filter by searching. Select {viewAllIssues} option from the Filters top bar item and enter your search criteria. Then, select {saveFilterAs} to create a filter',
		description:
			'Message for the empty state (empty screen) which is displayed for users on filters page in case there are no filters user has access to',
	},
	viewAllIssues: {
		id: 'directories.filters-v2.main.content.empty.view-all-issues',
		defaultMessage: 'View all issues',
		description:
			'Label for "View all issues" icon from the sidebar. This label is inserted as a reference in the empty state on the filters page (when there are no filters user has access to)',
	},
	saveFilterAs: {
		id: 'directories.filters-v2.main.content.empty.save-filter-as',
		defaultMessage: 'Save filter',
		description:
			'Label for "Save filter" button on the GIN page (where user searches issues). This label is inserted as a reference in the empty state on the filters page (when there are no filters user has access to)',
	},
});
